<!-- TODO: need to refacto with a ng-container instead of ion-list -->
<ion-list
  *ngIf="question.display"
  [ngSwitch]="question.controlType"
  [formGroup]="form"
  autocomplete="off"
>
  <ion-label class="bepatient-question-title">
    {{ question.label }}
  </ion-label>

  <bepatient-input-text
    *ngSwitchCase="'textbox'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-text>

  <bepatient-input-dropdown
    *ngSwitchCase="'dropdown'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-dropdown>

  <bepatient-input-range
    *ngSwitchCase="'range'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-range>

  <bepatient-input-toggle
    *ngSwitchCase="'toggle'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-toggle>

  <bepatient-input-checkbox
    *ngSwitchCase="'checkbox'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-checkbox>

  <bepatient-input-radio
    *ngSwitchCase="'radio'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-radio>

  <bepatient-input-datetime
    *ngSwitchCase="'datetime'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-datetime>

  <bepatient-input-textearea
    *ngSwitchCase="'textarea'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-input-textearea>

  <bepatient-field-nested-group
    *ngSwitchCase="'nestedGroupQuestion'"
    [question]="question"
    [parent]="form"
  >
  </bepatient-field-nested-group>
</ion-list>
